import Dashboard from './Dashboard';
import NgamenBizz from './NgamenBizz';

const pages = {
  Dashboard,
  NgamenBizz,
};

export default pages;
